import { donationsApi } from '../api/donationsApi'

export const getCashDonationReceipt = async (id: string) => {
  try {
    const {
      data: { downloadUrl, fileName },
    } = await donationsApi.getCashDepositReceipt(id)
    return { downloadUrl, fileName }
  } catch (error) {
    console.error(`Error fetching cash deposit receipt : ${id}: `, error)
    throw error
  }
}
